module.exports = __webpack_public_path__ + "static/media/e.c7767837.jpg";